<template>
  <div class="modal fade" id="BillBulkDelete" tabindex="-1" aria-hidden="true"  data-backdrop="static" redirected="viewAllBills">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 col-sm-5 col-lg-5 my-auto">
                <h5 class="modal-title" id="BillRunLogsLabel">Bulk Bill Delete</h5>
              </div>
              <div class="col-3 col-sm-7 my-auto">
                <div>
                  <div>
                    <span>
                      
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="container-fluid" v-if="error">
            <div class="row justify-content-center my-5">
              <h3>Successfully processed {{ count }} bills</h3>
            </div>
            <div class="row justify-content-center my-5">
              <div class="col-auto">
              <div class="alert alert-danger">
                {{error.title}}: {{error.body}}
              </div>
              </div>
            </div>
          </div>
          <div class="container-fluid" v-else-if="!loading">
            <div class="row justify-content-center my-5">
              <div class="col-auto">
                <h3 id="BillBulkDeleteTitle"><i class="fas fa-exclamation-triangle fa-3x " style="color:orangered"></i>
                  You are about to remove {{bills.length}} bills.
                </h3>
                <h3 id="BillBulkDeleteTitle2"><i class="fas fa-exclamation-triangle fa-3x " style="color:orangered"></i>
                  To continue, {{bills.length}} bills must be removed.
                </h3>
                <p class="text-center">Are you sure you want to proceed?</p>
              </div>
            </div>
          </div>
            <div class="container-fluid p-5" v-else>
            <div class="row justify-content-center my-5" >
              <div class="col-auto">
                <h3>Removing bill {{count}} of {{bills.length}}...</h3>
              </div>
            </div>
            <div>
              <div class="row justify-content-center my-5" >
                <div class="col-6">
            <div class="progress">
              <div class="progress-bar" role="progressbar" :aria-valuenow="rat" aria-valuemin="0" aria-valuemax="100" :style="`width: ${rat}%`"></div>
            </div>
          </div>
          </div>
          </div>
          </div>
        </div>
        <div class="modal-footer" v-if="!loading">
              <button class="btn btn-secondary mx-auto"
                          data-dismiss="modal" @click="returnToRedirect">Cancel</button>
              <button class="btn btn-danger mx-auto" @click="bulkDelete" v-if="!error">OK, Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//   import BillRunLogs from '@/json/logs.json'
import _filters from '@/mixins/filters.js';
import snotifyHttpError from '@/mixins/snotifyHttpResponses';
import moment from 'moment';
import { _ } from 'vue-underscore';

export default {
  name: 'BillDeleteBulk',
  mixins: [_filters, snotifyHttpError],

  data() {
    return {
      loading: false,
      count: 0,

      error: null,
    };
  },

  computed: {
    bills() {
      return _.sortBy(
        this.$store.state.finances.selectedBillsforBulkDelete,
        'PeriodStarts'
      ).reverse();
    },

    rat() {
      return (this.count / this.bills.length) * 100;
    },
  },

  mounted() {
    $('#BillBulkDelete').on('show.bs.modal', () => {
      this.error = null;
    });
  },

  methods: {
    async bulkDelete() {
      this.loading = true;
      this.count = 0;

      try {
        for (let bill of this.bills) {
          this.count++;
          await this.undoBill(bill);
        }
        this.returnToRedirect();
      } catch (err) {
        const e = this.snotifyHttpError(err);
        this.$snotify.error(e.body, e.title, e.config);
        this.count--;
        this.error = e;
      } finally {
        this.$store.commit(
          'updateSelectedBillsforBulkDelete',
          this.bills.slice(this.count)
        );

        if (this.count)
          this.$snotify.success(
            `${this.count} Bills proccesed`,
            'Bills Cancelled'
          );

        this.loading = false;

        this.$store.dispatch('getLedger');
        this.$store.dispatch('getCharges');
        this.$store.dispatch('getUsage');
        this.$store.dispatch('refreshReadings');
        this.$store.dispatch('getBills');
        this.$store.dispatch('refreshCustomer');
      }
    },

    async undoBill(bill) {
      const url = `https://${
        this.$config.honeycomb.billbotbillrun.domain
      }/api/v1/BillRuns/undo`;

      const res = await this.$http.put(
        url,
        { BillIds: [bill.Id] },
        { withCredentials: true }
      );

      if (!res.data.Processed.length) {
        throw new Error(
          `Bill cancellation failed to process bill on ${moment(
            bill.PeriodEnds
          ).format('DD/MM/YYYY')}`
        );
      }
    },

    returnToRedirect() {
      $('#BillBulkDelete').modal('hide');
      const to = document
        .getElementById('BillBulkDelete')
        .getAttribute('redirected');
      $(`#${to}`).modal('show');
    },
  },
};
</script>

<style>
#BillBulkDelete[redirected='viewAllBills'] #BillBulkDeleteTitle {
  display: block;
}
#BillBulkDelete[redirected='viewAllBills'] #BillBulkDeleteTitle2 {
  display: none;
}
#BillBulkDelete[redirected='Transfer'] #BillBulkDeleteTitle {
  display: none;
}
#BillBulkDelete[redirected='Transfer'] #BillBulkDeleteTitle2 {
  display: block;
}
</style>
